import Joi from '@hapi/joi';
import React from 'react';
import { IWithReactRouterProps } from '../../mixins/router/withReactRouter';

import { ITranslateProps, translate } from '../../mixins/translate';
import {
    Content,
    EditPanel,
    EditPanelButtons,
    EditPanelCell,
    EditPanelHeader,
    EditPanelRow,
    EditPanelSection,
    Panel,
    PanelBody,
    PanelButton,
    Tray,
} from '../elements';
import { Component } from '../utils/Component';
import {
    ValidatingEditPanelSaveButton,
    ValidatingEditPanelSwitch,
    ValidatingForm,
    ValidatingFormDependentSection,
    ValidatingFormInputDate,
    ValidatingFormInputText,
} from '../validatingElements';
import { CompanyDetailsLists } from './CompanyDetails';

export const licenceCreateSchema = Joi.object().keys({
    name: Joi.string().required(),
    expiresOnDate: Joi.date().when('isStandalone', { is: Joi.boolean().valid(false), then: Joi.required(), otherwise: Joi.allow(null, '') }),
    isStandalone: Joi.boolean().allow(null, ''),
    isInUseByDeviceName: Joi.string().allow(null, ''),
});

interface ICompanyLicenceAddEditProps extends ITranslateProps, IWithReactRouterProps {}

class CompanyLicenceAddEditComponent extends Component<ICompanyLicenceAddEditProps> {
    public override render() {
        return (
            <Content>
                <Tray>
                    <Panel>
                        <PanelBody>
                            <EditPanel>
                                <ValidatingForm
                                    schema={licenceCreateSchema}
                                    createUrl={`/api/companies/${this.props.location.query.companyId}/licences/`}
                                    onSubmitted={this.handleSavedOrCancelled}
                                    itemUrl={`/api/companies/${this.props.location.query.companyId}/licences/${this.props.location.query.licenceId}`}
                                    id={this.props.location.query.licenceId}
                                >
                                    <EditPanelHeader text={this.props.t('licence.licence')} />
                                    <EditPanelSection>
                                        <ValidatingFormInputText name="name" placeholder={this.props.t('common.name')} />
                                    </EditPanelSection>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <ValidatingEditPanelSwitch name="isStandalone" placeholder={this.props.t('licence.isStandalone')} />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <ValidatingFormDependentSection showIf={(item) => !item.isStandalone}>
                                        <EditPanelSection>
                                            <ValidatingFormInputDate name="expiresOnDate" placeholder={this.props.t('licence.expiresOnDate')} />
                                        </EditPanelSection>
                                    </ValidatingFormDependentSection>
                                    {this.props.location.query.licenceId && (
                                        <>
                                            <EditPanelHeader text={this.props.t('licence.deviceName')} />
                                            <EditPanelRow>
                                                <EditPanelCell rowCount={6}>
                                                    <ValidatingFormInputText
                                                        name="isInUseByDeviceName"
                                                        placeholder={this.props.t('licence.deviceName')}
                                                    />
                                                </EditPanelCell>
                                            </EditPanelRow>
                                        </>
                                    )}
                                    <EditPanelButtons>
                                        <PanelButton text={this.props.t('common.cancel')} onClick={this.handleSavedOrCancelled} />
                                        <ValidatingEditPanelSaveButton />
                                    </EditPanelButtons>
                                </ValidatingForm>
                            </EditPanel>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        );
    }

    private readonly handleSavedOrCancelled = () => {
        this.props.navigate(`/companies/${this.props.location.query.companyId}?list=${CompanyDetailsLists.License}`);
    };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CompanyLicenceAddEdit = translate()(CompanyLicenceAddEditComponent);
